<template>
  <div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Container Details</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button size="sm" variant="warning" @click="goToMain">New Container</b-button>

              <b-button
                size="sm"
                class="ml-2"
                :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                @click="getData('Excel')"
                variant="outline-info"
                > {{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>

            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <b-container fluid>
              <!-- User Interface controls -->
              <b-row>
                <b-col md="12" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type to Search"/>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Main table element -->
            <div class="table-responsive tableMain">
              <b-table
                show-empty
                stacked="md"
                :items="vehicleSizeMaster"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
              >
                <template slot="containerTypeId" slot-scope="row0">
                  <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                </template>
                <template slot="containerType" slot-scope="row1">
                  <span
                    @click="viewContainerPage(row1.item.containerTypeId)"
                    class="showMoreData"
                  >{{row1.item.containerType}}</span>
                </template>
                <template slot="loginTime" slot-scope="row11">
                  <span>{{row11.item.loginTime | moment}}</span>
                </template>

                <template slot="isContainerTypeActive" slot-scope="row11">
                  <div v-if="adminToggle == 'Admin'" :id="'row' + row11.item.containerTypeId">
                    <md-switch
                      :id="'approval' + row11.item.containerTypeId"
                      name="approval"
                      class="md-primary"
                      :value="row11.item.isContainerTypeActive == 1 ? true : false"
                      @change="activateUser(row11.item)"
                    >
                      <h6>
                        <br/>
                        <b-badge style="margin-left: -45px">{{
                          row11.item.isContainerTypeActive == 1 ? "Active" : "In-Active"
                        }}</b-badge>
                      </h6>
                    </md-switch>
                  </div>
                  <div v-else :id="'row' + row11.item.containerTypeId">
                    <h6>
                      <b-badge>{{
                        row11.item.isContainerTypeActive == 1 ? "Active" : "In-Active"
                      }}</b-badge>
                    </h6>
                  </div>
                </template>

                <!-- <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="deleteData(item1.containerTypeId)"
                        >
                          <md-icon>delete_sweep</md-icon>
                </md-button>-->
              </b-table>
            </div>

              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination

                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </b-container>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/container/containerSize");
      if (globalPermissionStatus("containerMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("containerMaster")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
      this.getData("Normal");
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      fields: [
        {
          key: "containerTypeId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "containerType",
          label: "Container Type",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "maxPayload",
          label: "Max Payload",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "loginTime",
          label: "Creation Date",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "isContainerTypeActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      containerSize: "",
      deleteId: "",

      vehicleSizeMaster: [
        {
          SrNo: "1"
          //  "vehicleSize":"1",
          //  "icon":"delete"
        }
      ],
      validate: true,
      containerSizeError: "",

      indexNew: "",
      deleteId: "",
      itemObj: {},
      adminToggle: this.$sessionsStorage.get("designation")
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  mounted() {
    //this.JqueryFun()
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.$router.push({
        path: "/container/containerType"
      });
    },
    JqueryFun() {
      return $(function() {
        return $("#vehicleSizenew").DataTable();
      });
    },

    validateAddVehicleSizeForm() {
      let validate_new = true;

      if (this.containerSize == "") {
        $("#containerSize").focus();
        this.containerSizeError = "Enter Container Size";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    viewContainerPage(containerID) {
      // console.log(driverID);
      this.$sessionsStorage.set("editContainerId", containerID);
      this.$router.push({
        path: "/container/containerType"
      });
    },

    getData(type) {
      let type_Size = {
        containerType: "containerType",
        Param:'List',
        type: type
      };

      if(type == "Excel"){
        this.ExcelBtnName = "Downloading....";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewContainerType.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.vehicleSizeMaster = data.containerTypeArray;
            this.totalRows = data.containerTypeArray.length;

            if (type == "Excel") {
              if (data.containerTypeArray.length > 0) {
                this.vehicleSizeMaster = data.containerTypeArray;
                this.totalRows = data.containerTypeArray.length;
                this.ExcelBtnName = "Export as Excel";
              }
              window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.containerTypeArray.length > 0) {
                this.vehicleSizeMaster = data.containerTypeArray;
                this.totalRows = data.containerTypeArray.length;
                console.log("Vehicle Size Master List response=>", data);
              }
            }

            //  console.log("fsf",data.truckSizeDetails)
            this.JqueryFun();
          }
        })
        .catch(error => {});
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "containertypemaster",
          tableId: "containerTypeId",
          tableIsActive: "isContainerTypeActive",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (
              data.clientId != "" &&
              
              status == 200 &&
              data
            ) {
              this.JqueryFun();
              this.getData("Normal");
              // console.log(data);
            }
          })
          .catch(error => {});
      }
    },

    activateUser(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.containerTypeId;

      this.itemObj.isContainerTypeActive = this.itemObj.isContainerTypeActive == 1 ? 0 : 1;
      let paylod = {
        tableName: "containertypemaster",
        tableId: "containerTypeId",
        tableIsActive: "isContainerTypeActive",
        value1: this.itemObj.isContainerTypeActive,
        tableVal: this.deleteId,
        isMailSend:'No',
        manual:'No',
      };

      
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          console.log("Salil Result => ", result);
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.getData("Normal");
          }
        })
        .catch((error) => {});

      // this.alert.content = true
      //   ? "Are you sure you want to Activate this User?"
      //   : "Are you sure you want to Deactivate this User?";
      // this.$refs["addPop6"].open();
    }
  }
};
</script>
<style scoped>
.table-bordered > tbody > tr > td,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > td,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > thead > tr > th {
  border: none !important;
}
table {
  border-radius: 10px !important;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  position: absolute;
  bottom: 14px;
  right: 8px;
  display: block;
  font-family: "Glyphicons Halflings";
  opacity: 0.2;
}

.table-bordered {
  border: 1px solid #ddd;
  border-radius: 10px !important;
  overflow: hidden;
}
.table > thead {
  background-color: #2f2752;
  color: #fff;

  /* font-weight: unset;
  font-size: 15px; */
}

.table > thead > tr > th {
  vertical-align: middle !important;
  padding: 15px !important;
}
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}

</style>


// WEBPACK FOOTER //
// viewContainerType.vue?37b39cc4